import { Method } from 'axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class RenameAlbumAPICal extends APICallV4 {
    _method = 'album/rename';
    _type: Method = 'post';
}
